
import React from "react";

function RedirectModal({ message }) {
  if (!message) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={logosContainerStyle}>
          <img
            src="https://static.wixstatic.com/media/5715af_a286bfb446374a96877a4193a1ef0933~mv2.png/v1/fill/w_114,h_60,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/PAT%20Logo.png"
            alt="PAT Logo"
            style={logoStyle}
          />
          <img
            src="https://static.wixstatic.com/media/77a25b_ec2fa92086954799bf72699afde7a666~mv2.png/v1/fill/w_191,h_34,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/VMKGBLUE.png"
            alt="VMKG Logo"
            style={logoStyle}
          />
        </div>
        
        <div style={iconContainerStyle}>
          <div style={spinnerStyle}></div>
          <svg
            style={checkIconStyle}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        
        <h3 style={titleStyle}>Session Detected</h3>
        <p style={messageStyle}>{message}</p>
        
        <div style={progressBarContainerStyle}>
          <div style={progressBarStyle}></div>
        </div>
        
        <p style={subtextStyle}>Please wait...</p>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  backdropFilter: "blur(4px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  animation: "fadeIn 0.3s ease-out",
};

const modalStyle = {
  backgroundColor: "#ffffff",
  padding: "40px 36px",
  borderRadius: "16px",
  maxWidth: "440px",
  width: "90%",
  textAlign: "center",
  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3), 0 0 1px rgba(0, 0, 0, 0.1)",
  animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
  position: "relative",
};

const logosContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "24px",
  marginBottom: "28px",
  paddingBottom: "24px",
  borderBottom: "1px solid #e5e7eb",
};

const logoStyle = {
  maxHeight: "50px",
  objectFit: "contain",
};

const iconContainerStyle = {
  width: "72px",
  height: "72px",
  margin: "0 auto 24px",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const spinnerStyle = {
  position: "absolute",
  width: "100%",
  height: "100%",
  border: "4px solid #e0e0e0",
  borderTop: "4px solid #4f46e5",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};

const checkIconStyle = {
  width: "36px",
  height: "36px",
  color: "#4f46e5",
  position: "relative",
  zIndex: 1,
};

const titleStyle = {
  margin: "0 0 12px",
  fontSize: "24px",
  fontWeight: "700",
  color: "#1a1a1a",
  letterSpacing: "-0.02em",
};

const messageStyle = {
  margin: "0 0 24px",
  fontSize: "16px",
  color: "#4b5563",
  lineHeight: "1.6",
};

const progressBarContainerStyle = {
  width: "100%",
  height: "4px",
  backgroundColor: "#e5e7eb",
  borderRadius: "2px",
  overflow: "hidden",
  marginBottom: "16px",
};

const progressBarStyle = {
  height: "100%",
  backgroundColor: "#4f46e5",
  borderRadius: "2px",
  animation: "progress 5s linear forwards",
};

const subtextStyle = {
  margin: 0,
  fontSize: "14px",
  color: "#9ca3af",
  fontWeight: "500",
};

// Add keyframe animations via a style tag
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  @keyframes progress {
    from { width: 0%; }
    to { width: 100%; }
  }
`;
document.head.appendChild(styleSheet);

export default RedirectModal;
